var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "phone-edit" },
    [
      _c(
        "ui-input",
        {
          staticClass: "input",
          attrs: {
            value: _vm.phone,
            readonly: "",
            mask: "phone",
            validate: ["required", "phone"],
            label: "Телефон*",
            placeholder: "Укажите ваш телефон"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "edit-icon",
              attrs: { slot: "append" },
              on: {
                click: function($event) {
                  _vm.phoneEditOpened = true
                }
              },
              slot: "append"
            },
            [
              _c("f-sprite-icon", {
                attrs: { "icon-link": _vm.$options.icons.IconEdit.id }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "modal",
        {
          attrs: { visible: _vm.phoneEditOpened },
          on: {
            "on-close": function($event) {
              _vm.phoneEditOpened = false
            }
          }
        },
        [
          _c("phone-edit-modal", {
            on: {
              "on-close": function($event) {
                _vm.phoneEditOpened = false
              },
              change: function($event) {
                _vm.phone = $event
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }